export const LOGIN = "/auth/login/";
export const LOGOUT = "/auth/logout/";
export const ME = "/me/";
export const USER = "/users/";
export const USER_FULLLIST = "/users/FullList";
export const PERMISSION = "/users/permissions_visible/";
export const PERMISSION_USER = "/users/add_permissions_to_user/";
export const PERMISSION_GROUP = "/users/add_permissions_to_group/";
export const ROL = "/roles/";
export const ROL_FULLLIST = "/roles/FullList";
export const ACCOUNT = "/account/account/";
export const ACCOUNT_FULLLIST = "/account/account/FullList";
export const CAMPAIGN = "/campaign/campaign/";
export const CAMPAIGN_FULLLIST = "/campaign/campaign/FullList/";
export const AUDITS = "/audits/audits/";
export const AUDITS_FULLLIST = "/audits/audits/FullList";
export const LOTE = "/lote/lote/";
export const LOTE_FULLLIST = "/lote/lote/FullList";
export const LEADS = "/leads/leads/";
export const LEADS_FULLLIST = "/leads/leads/FullList";
export const CASOS = "/casos/casos/";
export const CASOS_MATERIALS = "/casos/materialesCasos/";
export const CASOS_FULLLIST = "/casos/casos/FullList";
export const DASHBOARD = "/dashboard/";
export const CONTACTS = "/contact/contacto/";
export const CONTACTS_GET_USER = "/contact/contacto/get_contact_user/";
export const CONTACTS_FULLLIST = "contact/contacto/FullList";
export const CONTACTS_DATA = "/contact/datoContacto/";
export const CONTACTS_DATA_FULLLIST = "/contact/datoContacto/FullList";
export const CONTACTS_DOCUMENT = "/contact/documentoContacto/";
export const CONTACTS_DOCUMENT_FULLLIST = "/contact/documentoContacto/FullList";
export const CONTACTS_AGENT = "/contact/contacto/get_contact_agent/";

//GESTION CONTACTO
export const CALIFICACION_CONTACTO = "/contact/calificacionContacto/";
export const CALIFICACION_CONTACTO_LISTA = "/contact/calificacionContacto/FullList";
export const DESCRIPCION_CALIFICACION = "/contact/descripcionCalificacion/";
export const DESCRIPCION_CALIFICACION_LISTA = "/contact/descripcionCalificacion/FullList";
export const TIPO_GESTION_CONTACTO = "/contact/tipoGestion/";
export const TIPO_GESTION_CONTACTO_LISTA = "/contact/tipoGestion/FullList";
export const GESTION_CONTACTO = "/contact/gestionContacto/";
export const GESTION_CONTACTO_FULLLIST = "/contact/gestionContacto/FullList";


//HOJA DE VIDA
export const HOJA_CONTACTO = "/contact/hoja_contacto/";
export const EXPERIENCIA_HOJA = "/contact/experiencia_hoja/";
export const EDUCACION_HOJA = "/contact/educacion_hoja/";
export const CONOCIMIENTO_HOJA = "/contact/conociminetos_hoja/";

//CALENDAR
export const CALENDAR_EVENT = "/calendar/event/";
export const CALENDAR_GESTION = "/calendar/gestion_event/";
//Tasks

export const TASKS = "/tasks/";
export const TYPE_PROJECT = "/tasks/project-type/";
export const PROJECT = "/tasks/project/";

//SURVEY
export const SURVEY = "/survey/";

export const WHATHSAPP_CHAT = "whatsapp/message/contact_messages";
export const CONVERSATIONS = "whatsapp/conversation/"
export const PRODUCTOS = "/store/producto/";

//Pisos
export const PISO = "/hc/floor/";
export const PISO_FULLLIST = "/hc/floor/FullList";

//Areas
export const AREAS = "/hc/areas/";
export const AREAS_FULLLIST = "/hc/areas/FullList";

//Room  
export const ROOM = "/hc/room/";
export const ROOM_FULLLIST = "/hc/room/FullList";

//Patient
export const PATIENT = "/hc/patient/";

//Desinfeccion
export const DESINFECCION = "/hc/disinfection/";

//TARIFAS
export const TARIFAS = "/casos/tarifas-recoleccion/";

//REPORTES
export const REPORTES_GENERAR = "/reportes/reporte-agentes/";
export const REPORTES_EXCEL = "/reportes/reporte-agentes-excel/";
export const REPORTES_ACTAS = "/reportes/reporte-actas/";
export const REPORTES_ACTAS_EXCEL = "/reportes/reporte-actas-excel/";
export const REPORTES_DASHBOARD_AGENTE = "/reportes/dashboard-agente/";


// Base pblica del Front para construir URLs de QR
// Prioriza variables de entorno y permite fallback editable aqu
export const getPublicBaseUrl = () => {
  const fromEnv = process.env.REACT_APP_FRONT_BASE_URL || process.env.REACT_APP_PUBLIC_BASE_URL;
  const fallback = "https://limpia.grupoda2.com"; // Modifica este valor si prefieres fijarlo en cdigo
  const base = fromEnv || fallback || window.location.origin;
  return base.endsWith("/") ? base.slice(0, -1) : base;
};